export { default as stateFromHTML } from './stateFromHTML';


//////////////////
// WEBPACK FOOTER
// ../draft-js-import-html/esm/main.js
// module id = 2182
// module chunks = 25